import Vue from 'vue'
import select from 'dom-select'
import on from 'dom-event'
import { scrollToSelector } from 'lib/scrolls'
import { set, unset, contains, getHeight } from 'lib/util'
import state from 'lib/appState'

const ACCORDION_ACTIVE_CLASS = 'yotpo-faq__item--active'
const ACCORDION_CONTENT_SELECTOR = '.js-content'

export default (el) => new Vue({
  el,
  data () {
    return {
      faqs: window.HU.product_faqs,
      activeFaq: '',
      state
    }
  },
  watch: {
    'state.activeProduct': {
      handler () {
        setTimeout(() => {
          this.activeFaq = 'faq-1'
        }, 100)
        this.updateYotpo()
        this.toggleFaq()
        this.height()
      },
      deep: true
    }
  },
  mounted () {
    this.scrollToReviews()
    on(window, 'resize', () => {
      const active = select('.' + ACCORDION_ACTIVE_CLASS)
      if (active) {
        const content = select(ACCORDION_CONTENT_SELECTOR, active)
        content.style.height = getHeight(content.children[0])
      }
    })
    setTimeout(() => {
      this.activeFaq = 'faq-1'
    }, 500)
  },
  computed: {
    productFaqs () {
      if (this.faqs.length) {
        return this.faqs.filter(item => item.type === this.state.activeProduct.typeHandle)
      }
      return []
    }
  },
  methods: {
    updateYotpo () {
      const api = new window.Yotpo.API(yotpo)
      api.refreshWidgets()
    },
    toggleFaq (reference) {
      if (this.activeFaq === reference) {
        this.activeFaq = false
      } else {
        this.activeFaq = reference
      }
    },
    height (reference) {
      if (this.activeFaq !== reference) {
        return 0
      }
      if (!this.$refs[reference]) return null
      const heightFaq = Array.isArray(this.$refs[reference]) ? Number(this.$refs[reference][0].getBoundingClientRect().height) + 20 : Number(this.$refs[reference].getBoundingClientRect().height) + 20
      return heightFaq + 'px'
    },
    openReviewForm (event) {
      event.preventDefault()
      const api = new window.Yotpo.API(yotpo)
      api.openForm('review')

      if (document.querySelector('[data-score="5"]')) {
        document.querySelector('[data-score="5"]').click()
      }
    },
    scrollToReviews () {
      const urlParams = window.location.pathname
      if (urlParams.indexOf('reviews') !== -1) {
        scrollToSelector('.js-reviews-wrapper')
      }

      this.reviewStar = select('.js-reviews')
      if (this.reviewStar) {
        on(this.reviewStar, 'click', (e) => {
          e.preventDefault()
          scrollToSelector('.js-reviews-wrapper')
        })
      }
    }
  }
})
